//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gql } from 'graphql-tag'

const ARTICLE_QUERY = gql`
  query ($first: Int, $whereArticle: ContainerArticleFilterInput) {
    containerArticles(where: $whereArticle, first: $first, order: { article: { date: DESC } }) {
      nodes {
        id
        title
        isMainPoint
        useImage
        description
        article {
          id
          imageUrl
          date
          title
          slug
          externalId
          redirectUrl
          edition {
            id
            name
          }
          country {
            id
            name
          }
          region {
            id
            name
          }
          contentType {
            id
            name
            colour
            contentTypeGroup {
              id
              name
            }
          }
        }
      }
    }
  }
`

export default {
  name: 'LiveBlogSummaryBlock',
  props: {
    isWhite: {
      type: Boolean,
      default: false
    },
    articleLimit: {
      type: Number,
      default: 6
    },
    isTopStoriesOverride: {
      type: Boolean || undefined,
      default: undefined
    }
  },
  data() {
    return {
      containerArticles: [],
      loading: false,
      refreshInterval: null
    }
  },
  computed: {
    language() {
      return this.$store.get('language/locale') || 'en'
    },
    isTopStories() {
      if (this.isTopStoriesOverride !== undefined) {
        return this.isTopStoriesOverride
      }

      return this.language === 'en'
    }
  },
  watch: {
    isTopStories() {
      this.refresh()
    }
  },
  beforeMount() {
    this.refreshInterval = setInterval(() => this.refresh(true), 5 * 60 * 1000)
  },
  beforeDestroy() {
    if (this.refreshInterval) clearInterval(this.refreshInterval)
  },
  async mounted() {
    this.$store.set('dataFetchingCount/dataFetchingCount', this.$store.get('dataFetchingCount/dataFetchingCount') + 1)
    await this.refresh()
    this.$store.set('dataFetchingCount/dataFetchedCount', this.$store.get('dataFetchingCount/dataFetchedCount') + 1)
  },
  methods: {
    async refresh(purge = false) {
      this.loading = true
      const dateFrom = this.$dayjs().startOf(
        this.isTopStories ? this.$config.homepageLiveblogTimeframeEng : this.$config.homepageLiveblogTimeframe
      )
      const dateTo = this.$dayjs().endOf(
        this.isTopStories ? this.$config.homepageLiveblogTimeframeEng : this.$config.homepageLiveblogTimeframe
      )

      const whereArticle = {
        containerId: {
          eq: this.isTopStories ? this.$config.homepageLiveblogContainerIdEng : this.$config.homepageLiveblogContainerId
        },
        article: {
          isActive: {
            eq: true
          },
          date: {
            gte: dateFrom,
            lt: dateTo
          }
        }
      }

      const { data } = await this.$apollo.query({
        query: ARTICLE_QUERY,
        variables: {
          whereArticle,
          first: this.articleLimit
        },
        fetchPolicy: purge ? 'network-only' : 'cache-first'
      })

      this.containerArticles = data.containerArticles.nodes

      this.loading = false
    },
    navigate(article) {
      if (article.redirectUrl) window.location.href = article.redirectUrl
      else {
        this.$router.push({
          path: `/${this.getContentTypeUrlName(article.contentType)}/${article.slug}--${article.externalId}`
        })
      }
    }
  }
}
